import AtomicLoggingIn from "../../../../src/courses/partials/atomic/logging-in.mdx";
import * as React from 'react';
export default {
  AtomicLoggingIn,
  React
};